// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j0NEe","col":"styles_col__aNhu3"};